import { useContext } from "react";
import { AttributePairValidationContext } from "../contexts/attribute-validation-provider";

export const useAttributePairValidation = () => useContext(AttributePairValidationContext);
